'use client'

import { ReactNode } from 'react'
import { usePathname } from 'next/navigation'
import clsx from 'clsx'

type Props = {
  children: ReactNode
}

const authRoutes = new Set([
  '/forgot-password',
  '/login',
  '/reset-password',
  '/signup',
])

export default function HeaderContainer({ children }: Props) {
  const path = usePathname()
  const posIsFixed = !path.startsWith('/portal') && !authRoutes.has(path)

  return (
    <header
      className={clsx(
        posIsFixed ? 'fixed' : 'relative',
        'top-0 z-50 w-full border-b border-[#ececef] bg-white font-sans',
      )}
    >
      {children}
    </header>
  )
}
